import {runWebviewToAppBridge} from '~/common/utils/webview';

export function webViewCloseGuestOptionsMenu(value = true) {
  runWebviewToAppBridge('closeGuestOptionsMenu', value);
}
